/*
 * Model for KB Profile section
 */

define([
  "backbone",
  "messaging/messenger",
  "modules/shared/adminMenu/adminMenuModel",
  "modules/tasks/tasksModel",
], function (Backbone, Messenger, AdminMenuModel) {
  var KbProfileModel = {};

  KbProfileModel.privilegedAreaModel = new Backbone.Model({
    title: "admin.title.privilegedAreaTitle",
    nameAttribute: "roleName",
    namespace: "kb:profile:privilegedAreas",
    descriptionAttribute: "roleDescription",
    addModalTitle: "admin.addPrivilegedAreaRole",
    editModalTitle: "admin.editPrivilegedAreaRole",
    deleteMessage: "admin.deletePrivilegedAreaRole",
    deleteTooltip: "admin.tooltip.deletePrivilegedAreaRole",
    reqres: "kb:privileged:area:roles",
    trackType: "Privileged Area Role",
  });

  KbProfileModel.learnerStatusesModel = new Backbone.Model({
    title: "admin.title.learnerStatusTitle",
    nameAttribute: "value",
    namespace: "kb:profile:learnerStatuses",
    addModalTitle: "admin.addLearnerStatus",
    editModalTitle: "admin.editLearnerStatus",
    deleteMessage: "admin.deleteLearnerStatus",
    deleteTooltip: "admin.tooltip.deleteLearnerStatus",
    reqres: "kb:mart:statuses",
    trackType: "Learner Status",
  });

  KbProfileModel.contentAwarenessModel = new Backbone.Model({
    title: "admin.title.contentAwarenessSubtitle",
    nameAttribute: "value",
    namespace: "kb:profile:contentAwareness",
    addModalTitle: "admin.addContentAwareness",
    editModalTitle: "admin.editContentAwareness",
    deleteMessage: "admin.deleteContentAwareness",
    deleteTooltip: "admin.tooltip.deleteContentAwareness",
    reqres: "kb:content:awareness:ignored:urls",
    trackType: "Content Awareness",
  });

  KbProfileModel.taskTemplateModel = new Backbone.Model({
    title: "admin.title.taskTemplates",
    nameAttribute: "name",
    descriptionAttribute: "description",
    namespace: "kb:profile:taskTemplates",
    addModalTitle: "",
    editModalTitle: "",
    deleteMessage: "admin.deleteTaskTemplate",
    deleteTooltip: "admin.tooltip.deleteTaskTemplate",
    reqres: "task:templates",
    trackType: "Task Template",
  });

  Messenger.reqres.setHandler("kb:admin:menu:items", function () {
    var activeKb = Messenger.reqres.request("active:kb:model");
    var menuItems = new AdminMenuModel.menuItems([
      {
        name: "kbSettings",
        label: "admin.title.kbSettingsTitle",
        default: true,
      }, //selected by default
      {
        name: "dailyRefresh",
        label: "admin.title.dailyRefresh",
      },
    ]);

    if (activeKb.get("actionGroups")) {
      menuItems.add({
        name: "cancelActionLabels",
        label: "admin.title.cancelActionLabels",
      });
    }

    menuItems.add([
      {
        name: "contentAwareness",
        label: "admin.title.contentAwarenessTitle",
      },
      {
        name: "convertBackslash",
        label: "admin.title.convertBackslash",
      },
      {
        name: "defaultURL",
        label: "admin.title.defaultURL",
      },
      {
        name: "learnerStatuses",
        label: "admin.title.learnerStatusTitle",
      },
      {
        name: "privilegedAreas",
        label: "admin.title.privilegedAreaTitle",
      },
      {
        name: "responseSettings",
        label: "admin.title.responseSettingsTitle",
      },
      {
        name: "responseStyles",
        label: "admin.title.responseStylesTitle",
      },
      {
        name: "surveyLabels",
        label: "admin.title.surveyLabels",
      },
      {
        name: "uiConfigs",
        label: "admin.title.uiConfigs",
      },
      {
        name: "taskTemplates",
        label: "admin.title.taskTemplates",
      },
    ]);

    if (activeKb.get("recommendations")) {
      menuItems.add([
        {
          name: "recommendations",
          label: "admin.title.recommendations",
        },
      ]);
    }

    menuItems.add([
      {
        name: "advancedConfiguration",
        label: "admin.title.advancedConfiguration",
      },
    ]);
    return menuItems;
  });

  Messenger.reqres.setHandler("kb:admin:menu:style", function () {
    return new AdminMenuModel.menuType({
      type: "pills",
      stacked: true,
    });
  });

  return KbProfileModel;
});
